var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

import PropTypes from 'prop-types';

var CardMessages = function (_React$Component) {
  _inherits(CardMessages, _React$Component);

  function CardMessages() {
    _classCallCheck(this, CardMessages);

    return _possibleConstructorReturn(this, (CardMessages.__proto__ || Object.getPrototypeOf(CardMessages)).apply(this, arguments));
  }

  _createClass(CardMessages, [{
    key: 'render',
    value: function render() {
      return React.createElement(
        'div',
        { className: 'cf-card__messages' },
        this.props.messages.map(function (message, index) {
          return React.createElement(
            'div',
            {
              key: index,
              role: 'alert',
              className: 'cf-card__message cf-card__message--' + message.type
            },
            message.content
          );
        })
      );
    }
  }]);

  return CardMessages;
}(React.Component);

CardMessages.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.oneOf(['info', 'success', 'error', 'warning']),
    content: PropTypes.any.isRequired
  })).isRequired
};

export default CardMessages;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-card/es/CardMessages.js
// module id = 651
// module chunks = 0